export default __webpack_public_path__ + "static/media/06.572a0c61.jpg";